import { timeOptions } from 'constants';
import { create } from 'zustand';
export const useHomeStore = create((set, get) => ({
  selectedDateFilter: timeOptions.find(opt=>opt.value===2),
  setSelectedDateFilter: (selectedDateFilter = {}) => set(() => ({ selectedDateFilter })),
}));

